export default class Permission {

    static ROUTE_USERS = 'ROUTE_USERS';
    static ROUTE_PROJECTS = 'ROUTE_PROJECTS';
    static ROUTE_ACCOUNT = 'ROUTE_ACCOUNT';

    static all(){

        return Object.keys(Permission);
    }
}